<template>
  <div class="p-2 bgCommon">
    <modal-renew-membership
      v-if="selectedSupplier"
      :supplier="selectedSupplier"
      modal-type="supplier-list"
      @refetch-data="refetchData"
    />
    <modal-update-moneylender-license-expiry
      v-if="selectedSupplier"
      :supplier="selectedSupplier"
      @refetch-data="refetchData"
    />
    <modal-upload-rate-detail
      :supplier="selectedSupplierForUploadRate"
      :upload-rate-data="uploadRateData"
      :loading="uploadRateLoading"
    />
    <modal-password-edit :supplier-info="supplierInfo" />
    <modal-add-coin :supplier-coin="supplierCoin" @refetch-data="refetchData" />
    <modal-coin-record :supplier-data="supplierData" />
    <modal-sub-account
      :ability="ability"
      :account-id="accountId"
      :sub-account="subAccount"
      @reset-password="triggerResetPasswordModal"
      @remove-account="removeItem"
    />
    <div
      class="d-flex flex-wrap mt-2 mb-1 align-items-center justify-content-between"
    >
      <div class="d-flex flex-wrap align-items-center mobile-w100">
        <div>
          <!-- <feather-icon size="16" icon="SearchIcon"></feather-icon> -->
          <span class="title-size text-nowrap">財務公司</span>
        </div>
        <div class="form-col-select ml-2">
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block"
          />
          <feather-icon size="18" icon="ChevronDownIcon" />
        </div>
        <div class="search-primary ml-0 ml-sm-1 mobile-w100 mt-1 mt-sm-0">
          <feather-icon size="16" icon="SearchIcon" />
          <b-form-input
            v-model="searchQuery"
            class="d-inline-block mr-1"
            placeholder="搜尋財務公司"
          />
        </div>
        <div class="search-primary ml-0 ml-sm-1 mobile-w100 mt-1 mt-sm-0">
          <v-select
            v-model="companyFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="companyOptions"
            label="name"
            :clearable="false"
            :reduce="(option) => option.id"
            placeholder="選擇公司／街客"
          />
        </div>
      </div>
      <b-button
        v-if="ability.can('create', 'supplier')"
        variant="primary"
        class="mobile-w100 mt-1 mt-sm-0"
        :to="{ name: 'suppliers-create' }"
      >
        <span class="text-nowrap">新增財務公司</span>
      </b-button>
    </div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card no-body class="">
        <b-card-body class="p-2">
          <b-table
            ref="refSupplierListTable"
            class="position-relative"
            :items="fetchSuppliers"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="未找到匹配的記錄"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #cell(coin_records)="data">
              <a
                class="ml-1"
                href="javascript:void(0)"
                @click="triggerShowCoinRecordModal(data.item.id)"
              >
                <font-awesome-icon icon="fas fa-file-invoice-dollar" />
              </a>
            </template>
            <!-- Column: create time -->
            <!-- <template #cell(created_at)="data">
          {{data.item.created_at.slice(0,10)}}
        </template> -->

            <template #cell(childs)="data">
              <!-- <b-button v-if="data.item.childs.length > 0" size="sm" @click="data.toggleDetails" class="mr-2 line-fix text-nowrap">
              {{ data.detailsShowing ? "隱藏" : "顯示" }}帳戶
            </b-button> -->
              <b-button
                v-if="data.item.childs.length > 0"
                size="sm"
                @click="triggerSubAccountModal(data.item.childs, data.item.id)"
                >顯示帳戶</b-button
              >
              <div v-else>沒有旗下帳戶</div>
            </template>

            <template #cell(uploadrate)="data">
              <span v-if="data.item.client_count">{{
                (
                  (data.item.valid_client_count * 100) /
                  data.item.client_count
                ).toFixed(2) + "%"
              }}</span>
            </template>

            <!-- <template #row-details="data">

          <b-card >
            <div>
              <b-badge class="m-1" v-for="(acc,index) of data.item.childs" :key="acc.created_at">
                  <span class="align-middle ml-50">{{acc.contact_name}}</span>
                  <span class="align-middle ml-50">({{acc.email}})</span>
                  <b-dropdown
                    class="action-trigger-btn sub_action"
                      :right="$store.state.appConfig.isRTL"
                    >
                      <template #button-content>
                        <div class="d-flex pl-50 border-left whiteBorder">
                          <feather-icon
                            icon="EyeIcon"
                            size="16"
                            class="align-middle"
                          />
                        </div>
                      </template>

                      <b-dropdown-item
                        v-if="ability.can('update', 'supplier')"
                        :to="{ name: 'suppliers-edit', params: { id: data.item.id } }"
                      >
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">修改資料</span>
                      </b-dropdown-item>

                      <b-dropdown-item v-if="ability.can('update','supplier')" @click="triggerResetPasswordModal(acc)">
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">更改密碼</span>
                      </b-dropdown-item>

                      <b-dropdown-item v-if="ability.can('delete','supplier')" @click="removeItem(acc)">
                        <feather-icon icon="Trash2Icon" />
                        <span class="align-middle ml-50">刪除帳戶</span>
                      </b-dropdown-item>
                  </b-dropdown>
              </b-badge>
            </div>
          </b-card>

        </template> -->
            <!-- Column: is_active -->
            <template #cell(is_active)="data">
              <feather-icon
                v-if="data.item.is_active"
                icon="CheckIcon"
                size="18"
                class="mr-50 text-success"
              />
            </template>

            <template #cell(is_member)="data">
              <feather-icon
                v-if="data.item.is_member"
                icon="CheckIcon"
                size="18"
                class="mr-50 text-success"
              />
            </template>
            <template #cell(need_sign_member_contract)="data">
              <feather-icon
                v-if="data.item.need_sign_member_contract"
                icon="CheckIcon"
                size="18"
                class="mr-50 text-success"
              />
            </template>
            <template #cell(can_view_report_directly)="data">
              <feather-icon
                v-if="data.item.can_view_report_directly"
                icon="CheckIcon"
                size="18"
                class="mr-50 text-success"
              />
            </template>

            <!-- 會員到期日模板 -->
            <template #cell(membership_expiry_date)="data">
              <span
                :class="{
                  'text-danger font-weight-bold':
                    isMembershipExpired(data.item.membership_expiry_date),
                }"
              >
                {{ data.item.membership_expiry_date || "-" }}
              </span>
            </template>

            <!-- 放債人牌照到期日模板 -->
            <template #cell(moneylender_license_expiry_date)="data">
              <span
                :class="{
                  'text-danger font-weight-bold':
                    isMoneylenderLicenseExpired(data.item.moneylender_license_expiry_date),
                }"
              >
                {{ data.item.moneylender_license_expiry_date || "-" }}
              </span>
            </template>

            <!-- Column: Actions -->
            <!-- -->
            <template #cell(actions)="data">
              <b-dropdown
                :class="`action-trigger-btn ${
                  totalSuppliers <= 3 ? 'hor' : 'ver'
                }`"
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content class="">
                  <feather-icon
                    icon="EyeIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  class="coins_btn"
                  v-if="ability.can('update', 'supplier')"
                  @click="triggerAddCoinModal(data.item)"
                >
                  <span class="svg_circle">
                    <feather-icon icon="DollarSignIcon" />
                  </span>
                  <span class="align-middle ml-50">充值</span>
                </b-dropdown-item>

                <!-- <b-dropdown-item
            :to="{ name: 'suppliers-detail', params: { id: data.item.id } }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">詳細資料</span>
            </b-dropdown-item> -->

                <b-dropdown-item
                  v-if="ability.can('update', 'supplier')"
                  :to="{ name: 'suppliers-edit', params: { id: data.item.id } }"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">修改資料</span>
                </b-dropdown-item>

                <b-dropdown-item @click="triggerRenewMembership(data.item)">
                  <feather-icon icon="DollarSignIcon" />
                  <span class="align-middle ml-50">續費/加購額度</span>
                </b-dropdown-item>

                <b-dropdown-item @click="triggerUpdateMoneylenderLicenseExpiry(data.item)">
                  <feather-icon icon="CalendarIcon" />
                  <span class="align-middle ml-50">修改放債人牌照到期日</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="ability.can('read', 'supplier')"
                  @click="manageDeviceBinding(data.item)"
                >
                  <feather-icon icon="SmartphoneIcon" />
                  <span class="align-middle ml-50">設備綁定管理</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="ability.can('update', 'supplier')"
                  @click="triggerResetPasswordModal(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">更改密碼</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="ability.can('update', 'supplier')"
                  @click="triggerNeedSignMemberContract(data.item)"
                >
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">{{
                    data.item.need_sign_member_contract
                      ? "取消強制簽署會員合約"
                      : "強制簽署會員合約"
                  }}</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="ability.can('update', 'supplier')"
                  @click="triggerCanViewReportDirectly(data.item)"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle ml-50">{{
                    data.item.can_view_report_directly
                      ? "取消直接查看報告權限"
                      : "允許直接查看報告"
                  }}</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="ability.can('read', 'supplier')"
                  @click="triggerUploadRateDetail(data.item)"
                >
                  <feather-icon icon="BarChartIcon" />
                  <span class="align-middle ml-50">查看上傳率詳情</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="ability.can('delete', 'supplier')"
                  @click="removeItem(data.item)"
                >
                  <feather-icon icon="Trash2Icon" />
                  <span class="align-middle ml-50">刪除帳戶</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                  {{ dataMeta.to }}個記錄</span
                >
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalSuppliers"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-card>
    </b-overlay>

    <!-- 設備綁定管理 Modal -->
    <b-modal
      id="modal-device-binding-management"
      title="設備綁定管理"
      size="lg"
      hide-footer
      @hidden="qrCodeData = null"
    >
      <div v-if="selectedSupplier">
        <div class="mb-3">
          <h5>{{ selectedSupplier.company_name_cn }}</h5>
          <small class="text-muted">供應商 ID: {{ selectedSupplier.id }}</small>
          <div
            v-if="selectedSupplier.childs && selectedSupplier.childs.length > 0"
            class="mt-2"
          >
            <small class="text-info">
              <feather-icon icon="UsersIcon" size="14" class="mr-1" />
              包含 {{ selectedSupplier.childs.length }} 個子帳戶
            </small>
          </div>
        </div>

        <!-- 載入中 -->
        <div v-if="deviceBindingLoading" class="text-center py-4">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2">載入設備綁定狀態中...</p>
        </div>

        <!-- 供應商列表 -->
        <div v-else>
          <div class="suppliers-list">
            <div
              v-for="supplier in suppliersList"
              :key="supplier.id"
              class="supplier-item p-3 mb-3 border rounded"
            >
              <div class="d-flex justify-content-between align-items-start">
                <div class="supplier-info">
                  <div class="d-flex align-items-center mb-2">
                    <feather-icon
                      :icon="supplier.is_main ? 'UserIcon' : 'UsersIcon'"
                      class="mr-2 text-primary"
                    />
                    <div>
                      <strong>{{ supplier.company_name_cn }}</strong>
                      <b-badge
                        :variant="supplier.is_main ? 'primary' : 'info'"
                        class="ml-2"
                      >
                        {{ supplier.is_main ? "主帳戶" : "子帳戶" }}
                      </b-badge>
                      <b-badge
                        v-if="supplier.has_binding"
                        variant="success"
                        class="ml-1"
                      >
                        已綁定
                      </b-badge>
                    </div>
                  </div>

                  <div class="supplier-details">
                    <small class="text-muted d-block">
                      <strong>供應商 ID:</strong> {{ supplier.id }}
                    </small>
                    <small class="text-muted d-block" v-if="supplier.email">
                      <strong>郵箱:</strong> {{ supplier.email }}
                    </small>

                    <!-- 已綁定設備信息 -->
                    <div
                      v-if="supplier.has_binding && supplier.binding"
                      class="mt-2 p-2 bg-light rounded"
                    >
                      <small class="text-success d-block">
                        <feather-icon
                          icon="SmartphoneIcon"
                          size="12"
                          class="mr-1"
                        />
                        <strong>已綁定設備:</strong>
                        {{ supplier.binding.device_summary || "未知設備" }}
                      </small>
                      <small class="text-muted d-block">
                        <strong>綁定時間:</strong>
                        {{
                          new Date(supplier.binding.bound_at).toLocaleString()
                        }}
                      </small>
                      <small
                        class="text-muted d-block"
                        v-if="supplier.binding.last_accessed_at"
                      >
                        <strong>最後訪問:</strong>
                        {{
                          new Date(
                            supplier.binding.last_accessed_at
                          ).toLocaleString()
                        }}
                      </small>
                    </div>
                  </div>
                </div>

                <div class="supplier-actions">
                  <!-- 未綁定：生成 QR Code -->
                  <b-button
                    v-if="!supplier.has_binding"
                    variant="primary"
                    size="sm"
                    @click="generateQrCode(supplier.id)"
                    :disabled="generatingQR"
                  >
                    <b-spinner
                      v-if="generatingQR"
                      small
                      class="mr-1"
                    ></b-spinner>
                    <feather-icon
                      v-else
                      icon="QrCodeIcon"
                      size="16"
                      class="mr-1"
                    />
                    生成 QR Code
                  </b-button>

                  <!-- 已綁定：解除綁定 -->
                  <b-button
                    v-else
                    variant="outline-danger"
                    size="sm"
                    @click="confirmUnbindDevice(supplier.binding)"
                  >
                    <feather-icon icon="XCircleIcon" size="16" class="mr-1" />
                    解除綁定
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- QR Code 顯示區域 -->
        <div v-if="qrCodeData" class="qr-code-section mt-4 pt-4 border-top">
          <h6 class="text-center mb-3">設備綁定 QR Code</h6>

          <div class="text-center mb-3">
            <div
              v-if="qrCodeData.qr_code"
              v-html="qrCodeData.qr_code"
              class="qr-code-container"
            ></div>
            <div v-else class="text-muted">
              <feather-icon icon="AlertCircleIcon" size="48" class="mb-2" />
              <p>QR Code 生成中...</p>
            </div>
          </div>

          <div class="qr-info bg-light p-3 rounded">
            <div class="row">
              <div class="col-md-12">
                <small class="text-muted d-block">
                  <strong>供應商:</strong>
                  {{
                    selectedSupplierForQR
                      ? selectedSupplierForQR.company_name_cn
                      : qrCodeData.supplier
                      ? qrCodeData.supplier.company_name_cn
                      : "未知"
                  }}
                </small>
                <small class="text-muted d-block" v-if="selectedSupplierForQR">
                  <strong>帳戶類型:</strong>
                  {{ selectedSupplierForQR.is_main ? "主帳戶" : "子帳戶" }}
                  <span
                    v-if="
                      !selectedSupplierForQR.is_main &&
                      selectedSupplierForQR.parent_name
                    "
                  >
                    (隸屬於: {{ selectedSupplierForQR.parent_name }})
                  </span>
                </small>
                <small
                  class="text-muted d-block"
                  v-if="selectedSupplierForQR && selectedSupplierForQR.email"
                >
                  <strong>綁定郵箱:</strong> {{ selectedSupplierForQR.email }}
                </small>
                <small class="text-muted d-block">
                  <strong>過期時間:</strong>
                  {{ new Date(qrCodeData.expires_at).toLocaleString() }}
                </small>
              </div>
            </div>
          </div>

          <div class="text-center mt-3">
            <small class="text-warning d-block mb-3">
              <feather-icon icon="ClockIcon" size="14" class="mr-1" />
              QR Code 將在 3 天後過期
            </small>

            <!-- 下載按鈕 -->
            <b-button variant="success" @click="downloadQrCode" class="mr-2">
              <feather-icon icon="DownloadIcon" size="16" class="mr-1" />
              下載 QR Code
            </b-button>
          </div>
        </div>

        <!-- Modal 底部按鈕 -->
        <div class="modal-footer-custom mt-4 pt-3 border-top">
          <b-button
            variant="secondary"
            @click="$bvModal.hide('modal-device-binding-management')"
          >
            關閉
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.qr-code-container {
  display: inline-block;
  max-width: 300px;
  max-height: 300px;
}

.qr-code-container svg {
  width: 100%;
  height: auto;
  max-width: 300px;
  max-height: 300px;
}

.supplier-item {
  transition: all 0.2s ease;
}

.supplier-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useSuppliersList from "./useSuppliersList";
import supplierStoreModule from "../supplierStoreModule";
import ModalPasswordEdit from "../modal/ModalPasswordEdit.vue";
import ModalAddCoin from "../modal/ModalAddCoin.vue";
import ModalCoinRecord from "../modal/ModalCoinRecord.vue";
import ModalSubAccount from "../modal/ModalSubAccount.vue";
import ModalRenewMembership from "../modal/ModalRenewMembership.vue";
import ModalUpdateMoneylenderLicenseExpiry from "../modal/ModalUpdateMoneylenderLicenseExpiry.vue";
import ModalUploadRateDetail from "../modal/ModalUploadRateDetail.vue";

export default {
  components: {
    ModalPasswordEdit,
    ModalAddCoin,
    ModalCoinRecord,
    ModalSubAccount,
    ModalUpdateMoneylenderLicenseExpiry,
    ModalUploadRateDetail,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    BSpinner,
    vSelect,
    ModalRenewMembership,
  },
  data() {
    return {
      supplierInfo: { id: 0, password: "", password_confirmation: "" },
      supplierCoin: {},
      supplierData: {},
      subAccount: [],
      accountId: 0,
      loading: false,
      selectedSupplier: {},
      // 設備綁定相關
      suppliersList: [],
      deviceBindingLoading: false,
      qrCodeData: null,
      generatingQR: false,
      selectedSupplierForQR: null,
      // 上傳率詳情相關
      selectedSupplierForUploadRate: null,
      uploadRateData: null,
      uploadRateLoading: false,
    };
  },
  methods: {
    triggerRenewMembership(supplier) {
      this.selectedSupplier = JSON.parse(JSON.stringify(supplier));
      this.$bvModal.show("modal-renew-membership-supplier-list");
    },
    triggerUpdateMoneylenderLicenseExpiry(supplier) {
      this.selectedSupplier = JSON.parse(JSON.stringify(supplier));
      this.$bvModal.show("modal-update-moneylender-license-expiry");
    },
    async triggerUploadRateDetail(supplier) {
      this.selectedSupplierForUploadRate = JSON.parse(JSON.stringify(supplier));
      this.uploadRateLoading = true;
      this.uploadRateData = null;
      
      // 顯示 modal
      this.$bvModal.show("modal-upload-rate-detail");
      
      try {
        // 調用 API 獲取上傳率詳情
        const response = await this.$http.get(`/supplier/${supplier.id}/upload-rate-detail`);
        this.uploadRateData = response.data;
      } catch (error) {
        console.error("Failed to load upload rate details:", error);
        this.$swal({
          title: "錯誤",
          text: "無法載入上傳率詳細資料，請稍後再試",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } finally {
        this.uploadRateLoading = false;
      }
    },
    manageDeviceBinding(supplier) {
      // 顯示設備綁定管理 modal
      this.selectedSupplier = JSON.parse(JSON.stringify(supplier));
      this.loadSupplierDeviceBindings(supplier.id);
      this.$bvModal.show("modal-device-binding-management");
    },
    triggerNeedSignMemberContract(item) {
      this.$swal({
        title: "你確定嗎?",
        text: item.need_sign_member_contract
          ? "取消後該財務公司將不需要強制簽署會員合約"
          : "設置後該財務公司必須重新簽署會員合約",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          console.log(item);
          this.$store
            .dispatch("app-supplier/updateNeedSignMemberContract", {
              id: item.id,
              need_sign_member_contract: !item.need_sign_member_contract,
            })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    triggerCanViewReportDirectly(item) {
      this.$swal({
        title: "你確定嗎?",
        text: item.can_view_report_directly
          ? "取消後該財務公司將無法直接查看報告"
          : "設置後該財務公司可以直接查看報告",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-supplier/updateCanViewReportDirectly", {
              id: item.id,
              can_view_report_directly: !item.can_view_report_directly,
            })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    triggerSubAccountModal(item, id) {
      this.subAccount = item;
      this.accountId = id;
      this.$bvModal.show("modal-sub-account");
    },
    triggerResetPasswordModal(item) {
      this.supplierInfo.id = item.id;
      this.supplierInfo.name = item.contact_name;
      this.supplierInfo.password = "";
      this.supplierInfo.password_confirmation = "";
      this.$bvModal.show("modal-reset-supplier-password");
    },
    triggerAddCoinModal(item) {
      this.supplierCoin.supplier_id = item.id;
      this.$bvModal.show("modal-supplier-add-coin");
    },
    triggerShowCoinRecordModal(id) {
      this.loading = true;
      this.$store
        .dispatch("app-supplier/fetchSupplierCoinRecords", id)
        .then((response) => {
          this.loading = false;
          this.supplierData = response.data.coin_records;
          // this.$swal({
          //   text: response.data.message,
          //   icon: "success",
          //   confirmButtonText: "確定",
          //   customClass: {
          //     confirmButton: "btn btn-primary",
          //   },
          //   showClass: {
          //     popup: "animate__animated animate__bounceIn",
          //   },
          //   buttonsStyling: false,
          // });
          this.$bvModal.show("modal-supplier-coin-record");
        });
    },
    removeItem(item, isSub) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的行動是最終的，您將無法檢索這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-supplier/deleteSupplierAccount", { id: item.id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              if (isSub) {
                this.subAccount = this.subAccount.filter(
                  (item2) => item2.id != item.id
                );
              }
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    // 設備綁定相關方法
    async loadSupplierDeviceBindings(supplierId) {
      this.deviceBindingLoading = true;
      this.suppliersList = [];
      this.qrCodeData = null;

      try {
        // 獲取主供應商和子供應商的綁定狀態
        const response = await this.$http.get(
          `/supplier_device/check/${supplierId}`
        );

        if (response.data.success) {
          this.suppliersList = response.data.data.suppliers || [];
          console.log("供應商列表數據:", response.data.data);
        }
      } catch (error) {
        console.error("載入設備綁定狀態失敗:", error);

        // 使用 SweetAlert 顯示錯誤
        this.$swal({
          title: "載入失敗",
          text: error.response?.data?.message || "載入設備綁定狀態失敗",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } finally {
        this.deviceBindingLoading = false;
      }
    },

    async generateQrCode(supplierId) {
      this.generatingQR = true;
      this.qrCodeData = null;

      // 找到選中的供應商信息
      const selectedSupplier = this.suppliersList.find(
        (s) => s.id === supplierId
      );
      this.selectedSupplierForQR = selectedSupplier;

      try {
        const response = await this.$http.post("/supplier_device/generate-qr", {
          supplier_id: supplierId,
        });

        if (response.data.success) {
          this.qrCodeData = response.data.data;
          console.log("QR Code 生成成功:", this.qrCodeData);
          console.log("QR Code SVG 內容:", this.qrCodeData.qr_code);

          this.$swal({
            title: "成功",
            text: "QR Code 生成成功",
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      } catch (error) {
        console.error("生成 QR Code 失敗:", error);
        const errorMessage =
          error.response?.data?.message || "生成 QR Code 失敗";
        this.$swal({
          title: "生成失敗",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } finally {
        this.generatingQR = false;
      }
    },

    async unbindDevice(bindingId) {
      try {
        const response = await this.$http.post(
          `/supplier_device/unbind/${bindingId}`
        );

        if (response.data.success) {
          this.$swal({
            title: "成功",
            text: "設備綁定已解除",
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          // 重新載入綁定狀態
          this.loadSupplierDeviceBindings(this.selectedSupplier.id);
        }
      } catch (error) {
        console.error("解除設備綁定失敗:", error);
        const errorMessage =
          error.response?.data?.message || "解除設備綁定失敗";
        this.$swal({
          title: "解綁失敗",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    confirmUnbindDevice(binding) {
      this.$swal({
        title: "確認解除設備綁定",
        text: `確定要解除 ${binding.device_summary || "此設備"} 的綁定嗎？`,
        showCancelButton: true,
        confirmButtonText: "確認解除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.unbindDevice(binding.id);
        }
      });
    },

    // 下載 QR Code
    downloadQrCode() {
      if (!this.qrCodeData || !this.selectedSupplierForQR) {
        this.$swal({
          title: "下載失敗",
          text: "QR Code 數據不完整",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      console.log("開始下載 QR Code...", this.qrCodeData);

      try {
        // 創建一個 canvas 來繪製 QR Code 和文字
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 設置 canvas 尺寸
        canvas.width = 400;
        canvas.height = 550;

        // 設置背景色
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 設置文字樣式
        ctx.fillStyle = "#333333";
        ctx.textAlign = "center";

        // 繪製標題
        ctx.font = "bold 24px Arial";
        ctx.fillText("設備綁定 QR Code", canvas.width / 2, 30);

        // 繪製供應商信息
        ctx.font = "bold 18px Arial";
        if (this.selectedSupplierForQR.company_name_cn) {
          ctx.fillText(
            this.selectedSupplierForQR.company_name_cn,
            canvas.width / 2,
            60
          );
        }

        ctx.font = "14px Arial";
        ctx.fillStyle = "#666666";
        let yOffset = 80;

        if (this.selectedSupplierForQR.email) {
          ctx.fillText(
            this.selectedSupplierForQR.email,
            canvas.width / 2,
            yOffset
          );
          yOffset += 20;
        }

        // 繪製帳戶類型
        const accountType = this.selectedSupplierForQR.is_main
          ? "主帳戶"
          : "子帳戶";
        ctx.fillText(`帳戶類型: ${accountType}`, canvas.width / 2, yOffset);
        yOffset += 20;

        // 如果是子帳戶，顯示父供應商信息
        if (
          !this.selectedSupplierForQR.is_main &&
          this.selectedSupplierForQR.parent_name
        ) {
          ctx.fillText(
            `隸屬於: ${this.selectedSupplierForQR.parent_name}`,
            canvas.width / 2,
            yOffset
          );
          yOffset += 20;
        }

        // 繪製過期時間
        const expireTime = new Date(this.qrCodeData.expires_at).toLocaleString(
          "zh-TW"
        );
        ctx.fillText(`過期時間: ${expireTime}`, canvas.width / 2, yOffset);

        // 嘗試從頁面中獲取 SVG 元素
        const qrContainer = document.querySelector(".qr-code-container svg");

        if (qrContainer) {
          console.log("找到 SVG 元素，開始轉換...");

          // 克隆 SVG 元素
          const svgClone = qrContainer.cloneNode(true);
          svgClone.setAttribute("width", "300");
          svgClone.setAttribute("height", "300");

          // 將 SVG 轉換為圖片
          const svgData = new XMLSerializer().serializeToString(svgClone);
          const svgBlob = new Blob([svgData], {
            type: "image/svg+xml;charset=utf-8",
          });
          const svgUrl = URL.createObjectURL(svgBlob);

          const img = new Image();
          img.crossOrigin = "anonymous";

          img.onload = () => {
            console.log("SVG 圖片載入成功，開始繪製...");

            // 繪製 QR Code
            const qrSize = 300;
            const qrX = (canvas.width - qrSize) / 2;
            const qrY = yOffset + 20;

            ctx.drawImage(img, qrX, qrY, qrSize, qrSize);

            // 下載圖片
            canvas.toBlob((blob) => {
              if (blob) {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `QRCode_${
                  this.selectedSupplierForQR.company_name_cn ||
                  this.selectedSupplierForQR.parent_name
                }_${accountType}.png`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);

                console.log("QR Code 下載成功");
                this.$swal({
                  title: "下載成功",
                  text: "QR Code 已成功下載",
                  icon: "success",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              } else {
                throw new Error("無法生成圖片 blob");
              }
            }, "image/png");

            URL.revokeObjectURL(svgUrl);
          };

          img.onerror = (error) => {
            console.error("SVG 圖片載入失敗:", error);
            URL.revokeObjectURL(svgUrl);
            this.fallbackDownload();
          };

          img.src = svgUrl;
        } else {
          console.log("未找到 SVG 元素，使用備用方法...");
          this.fallbackDownload();
        }
      } catch (error) {
        console.error("下載 QR Code 失敗:", error);
        this.$swal({
          title: "下載失敗",
          text: "下載 QR Code 時發生錯誤: " + error.message,
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    // 備用下載方法
    fallbackDownload() {
      try {
        // 直接下載 SVG 文件
        const svgData = this.qrCodeData.qr_code;
        const blob = new Blob([svgData], { type: "image/svg+xml" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const accountType = this.selectedSupplierForQR.is_main
          ? "主帳戶"
          : "子帳戶";
        a.download = `QRCode_${this.selectedSupplierForQR.company_name_cn}_${accountType}.svg`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$swal({
          title: "下載成功",
          text: "QR Code 已下載為 SVG 格式",
          icon: "success",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } catch (error) {
        console.error("備用下載方法也失敗:", error);
        this.$swal({
          title: "下載失敗",
          text: "所有下載方法都失敗了",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-supplier";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchSuppliers,
      tableColumns,
      perPage,
      currentPage,
      totalSuppliers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSupplierListTable,
      refetchData,
      suppliersList,
      ability,
      companyOptions,
      companyFilter,
      isMembershipExpired,
      isMoneylenderLicenseExpired,
    } = useSuppliersList();

    return {
      // Sidebar
      fetchSuppliers,
      tableColumns,
      perPage,
      currentPage,
      totalSuppliers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSupplierListTable,
      refetchData,
      suppliersList,
      ability,
      companyOptions,
      companyFilter,
      isMembershipExpired,
      isMoneylenderLicenseExpired,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
.coins_btn {
  display: flex;
  .dropdown-item {
    display: flex;
    align-items: center;
    width: 100%;
    &:hover {
      .svg_circle {
        border-color: $primary;
      }
    }
    .svg_circle {
      border: 1px solid #6e6b7b;
      border-radius: 100%;
      width: 18px;
      height: 18px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
}
.app-timeline {
  max-height: 550px;
  overflow: auto;
  padding-left: 7px !important;
}
</style>
